
export default
  props:
    channel:{kind:Object}

  computed:
    firstLetter:()->
      @channel.name.charAt(0)

